const envEmsBaseUrl = process.env.REACT_APP_EMS_BASE_URL;

export const EMS_BASE_URL =
  envEmsBaseUrl && envEmsBaseUrl.trim().length > 0
    ? envEmsBaseUrl
    : "https://ems.madayn.om";
